module.exports = "/_next/static/images/Johnathan_Mathew_L-4d40d64cdd922a1504e4e5176620ca82.webp";